import { TEMPLATE_SET_KEY_REGEX } from '@pams/shared';

/**
 * ─────────────────────────────────────────────────────────────────────────────────────
 *  [P7B.1 §3b] "CREATE A POST TYPE FOR THIS COLUMN" — THE NEW-POST-TYPE DRAWER, PREFILLED FROM THE URL.
 *
 *  `/post-types?new=1&name=…&shortName=…&column=…&from=templates&setKey=…` opens the create drawer with
 *  the booklet's words in it. The super admin reviews, picks the eligible ranks and saves through the
 *  ordinary create — `postType.write`, `POST_TYPE_CREATED` unchanged — and is sent back to the column
 *  decision. No template code creates a post type. `PolicyBuilder/prefill.ts` is the precedent.
 *
 *  ⚠️ `null` WITHOUT `new=1`, so `/post-types` is byte-for-byte what it was. Every value is cut to the
 *  master's own limits rather than sent whole: a hand-edited link must not put a value in the form that
 *  the create would refuse with a 422 naming a field nobody typed.
 * ─────────────────────────────────────────────────────────────────────────────────────
 */
export type PostTypePrefill = {
  name: string;
  shortName: string;
  /** The booklet column it is for, and the set to return to — only when the link came from the decisions. */
  templates: { setKey: string; column: string } | null;
};

/** A decision code's own bound (`recordTemplateDecisionSchema`) — the column travels back as one. */
const COLUMN_MAX = 300;

export const postTypePrefillOf = (params: URLSearchParams): PostTypePrefill | null => {
  if (params.get('new') !== '1') return null;
  const setKey = params.get('setKey');
  const column = params.get('column')?.trim() ?? '';
  return {
    name: (params.get('name') ?? '').trim().slice(0, 120),
    shortName: (params.get('shortName') ?? '').trim().slice(0, 40),
    templates:
      params.get('from') === 'templates' &&
      setKey !== null &&
      TEMPLATE_SET_KEY_REGEX.test(setKey) &&
      column !== '' &&
      column.length <= COLUMN_MAX
        ? { setKey, column }
        : null,
  };
};
